module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/building icon-ba4f8e58.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/building icon.svg
// module id = ./app/web/src/assets/building icon.svg
// module chunks = 0